import { Calendar, type CalendarProps } from "@bookingcom/bui-react";
import { getDateWithOffset } from "../../../utils/date";
import type { DateRange } from "../../../types/date";
import { CAMPAIGN_PERFORMANCE_METRICS_AVAILABLE_DATE } from "../../../constants/campaignPerformance";
import styles from "../DateRangePicker.module.css";

export type DateRangePickerContentCalendarProps = {
  dateRange: Partial<DateRange>;
  onDateRangeChange?: (dataRange: Partial<DateRange>) => void;
};

export const DateRangePickerContentCalendar = ({
  dateRange: { startDate, endDate },
  onDateRangeChange = () => {},
}: DateRangePickerContentCalendarProps) => {
  const handleDateChange: CalendarProps["onDateChange"] = ({ startDate, endDate }) => {
    onDateRangeChange({ startDate: startDate || undefined, endDate: endDate || undefined });
  };

  return (
    <Calendar
      baseDate={startDate}
      startDate={startDate}
      endDate={endDate}
      minDate={CAMPAIGN_PERFORMANCE_METRICS_AVAILABLE_DATE}
      maxDate={getDateWithOffset(new Date(), -1)}
      firstWeekDay={1}
      previousAriaLabel="Previous month"
      nextAriaLabel="Next month"
      ariaLabel="Date range selection"
      startAccessibilityHint="Select as start date"
      endAccessibilityHint="Select as end date"
      mode="double"
      onDateChange={handleDateChange}
      dayClassName={styles.calendarDay}
    />
  );
};
